export default __webpack_public_path__ + "static/target-4db5ec253434dd5598a055d4bceb9c3a.png";